export const AUTO_CODER_LLM_DEFAULTS = {
  max_tokens: 5000,
  temperature: 0.6,
};

const MODEL_CONFIG = {
  "qwen-text": { safeTemperature: 0.6 },
  "gemma-text": { safeTemperature: 0.9 },
  "llama3.1": { safeTemperature: 0.4 },
  "llama3.2": { safeTemperature: 0.4 },
  "qwen-thinking": { safeTemperature: 0.7 },
  "gemma-thinking": { safeTemperature: 0.7 },
};

export const AUTO_CODER_ROLES = [
  { id: "developer", label: "Developer" },
  { id: "system_architect", label: "System Architect" },
  { id: "code_reviewer", label: "Code Reviewer" },
  { id: "debugger", label: "Debugger" },
  { id: "custom", label: "Custom" },
];

export const AUTO_CODER_MODELS = [
  {
    id: "qwen-text",
    label: "Qwen Text",
    defaultRoleId: "developer",
    parameters: { ...AUTO_CODER_LLM_DEFAULTS },
  },
  {
    id: "llama3.1",
    label: "Llama 3.1",
    defaultRoleId: "developer",
    parameters: { ...AUTO_CODER_LLM_DEFAULTS },
  },
  {
    id: "llama3.2",
    label: "Llama 3.2",
    defaultRoleId: "developer",
    parameters: { ...AUTO_CODER_LLM_DEFAULTS },
  },
  {
    id: "gemma-text",
    label: "Gemma Text",
    defaultRoleId: "developer",
    parameters: { ...AUTO_CODER_LLM_DEFAULTS },
  },
  {
    id: "qwen-thinking",
    label: "Qwen Thinking",
    defaultRoleId: "developer",
    parameters: { ...AUTO_CODER_LLM_DEFAULTS },
  },
  {
    id: "gemma-thinking",
    label: "Gemma Thinking",
    defaultRoleId: "developer",
    parameters: { ...AUTO_CODER_LLM_DEFAULTS },
  },
];

export const AUTO_CODER_PARAMETER_LIMITS = {
  temperature: { min: 0, max: 2, step: 0.1 },
  max_tokens: { min: 256, max: 10000, step: 256 },
};

export const getAutoCoderModel = (modelId) =>
  AUTO_CODER_MODELS.find((m) => m.id === modelId) || AUTO_CODER_MODELS[0];

export const getAutoCoderRole = (roleId) =>
  AUTO_CODER_ROLES.find((r) => r.id === roleId) || AUTO_CODER_ROLES[0];

export const getModelsForMode = (deepResearch) => {
  const thinkingIds = ["qwen-thinking", "gemma-thinking"];
  return AUTO_CODER_MODELS.filter((m) =>
    deepResearch ? thinkingIds.includes(m.id) : !thinkingIds.includes(m.id)
  );
};

export const getInitialGenerationSettings = () => ({
  modelId: "qwen-text",
  roleId: "developer",
  parameters: { ...AUTO_CODER_LLM_DEFAULTS },
  deepResearch: false,
});

export const applyModelToSettings = (currentSettings, modelId) => {
  const model = getAutoCoderModel(modelId);
  const role = getAutoCoderRole(model.defaultRoleId);

  // merge defaults with model-specific safeTemperature
  const parameters = {
    ...AUTO_CODER_LLM_DEFAULTS,
    temperature: MODEL_CONFIG[model.id]?.safeTemperature ?? AUTO_CODER_LLM_DEFAULTS.temperature,
  };

  return {
    ...currentSettings,
    modelId: model.id,
    roleId: role.id,
    parameters,
  };
};

export const applyRoleToSettings = (currentSettings, roleId) => {
  const role = getAutoCoderRole(roleId);

  return {
    ...currentSettings,
    roleId: role.id,
  };
};

export const applyDeepResearchToggle = (currentSettings, deepResearch) => {
  const targetModelId = deepResearch ? "qwen-thinking" : "qwen-text";
  const settingsWithToggle = {
    ...currentSettings,
    deepResearch,
  };
  return applyModelToSettings(settingsWithToggle, targetModelId);
};

export const buildConversationPayload = ({
  query,
  queryId,
  fileIds,
  generationSettings,
}) => ({
  query,
  query_id: queryId,
  file_id: fileIds,
  model: generationSettings.modelId,
  role: generationSettings.roleId,
  max_tokens: generationSettings.parameters.max_tokens,
  temperature: generationSettings.parameters.temperature,
  thinking: generationSettings.deepResearch === true,
});
 